import { render, staticRenderFns } from "./VisionSelect.vue?vue&type=template&id=627c283f&scoped=true&"
import script from "./VisionSelect.vue?vue&type=script&lang=js&"
export * from "./VisionSelect.vue?vue&type=script&lang=js&"
import style0 from "./VisionSelect.vue?vue&type=style&index=0&id=627c283f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627c283f",
  null
  
)

export default component.exports